import { render, staticRenderFns } from "./logsig_2_2.vue?vue&type=template&id=520cbcaa&scoped=true&"
import script from "./logsig_2_2.vue?vue&type=script&lang=js&"
export * from "./logsig_2_2.vue?vue&type=script&lang=js&"
import style0 from "./logsig_2_2.vue?vue&type=style&index=0&id=520cbcaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520cbcaa",
  null
  
)

export default component.exports